import { render, staticRenderFns } from "./DnevnaAktivnostMerchandisera.vue?vue&type=template&id=2068cf02&scoped=true&"
import script from "./DnevnaAktivnostMerchandisera.vue?vue&type=script&lang=ts&"
export * from "./DnevnaAktivnostMerchandisera.vue?vue&type=script&lang=ts&"
import style0 from "./DnevnaAktivnostMerchandisera.vue?vue&type=style&index=0&id=2068cf02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068cf02",
  null
  
)

export default component.exports